export const NOTIFICATION_TYPES = {
    SUCCESS: 1,
    WARNING: 3,
    ERROR: 4,
    ACTION: 5,
}

export const NOTIFICATION_ACTIONS = {
    MBA_UPGRADE: 'mba_upgrade',
}
